export function getPlayerApiUrl() {
  var { hostname } = document.location;

  if (hostname === "localhost") return "http://localhost:5001/player";

  return `https://api.${hostname}/player`;
}

export function getAdminApiUrl() {
  var { hostname } = document.location;

  if (hostname === "localhost") return "http://localhost:5000/admin";

  return `https://api.${hostname}/admin`;
}

export function getS3ApiUrl() {
  var { hostname } = document.location;

  if (hostname === "localhost") return "http://localhost:4000";

  return `https://${hostname}`;
}
